import GeoTIFFClass, * as GeoTIFFModule from './../../node_modules/ol/source/GeoTIFF.js';

class GeoTIFF extends GeoTIFFClass {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in GeoTIFFModule) {
    if (key !== "default") {
        GeoTIFF[key] = GeoTIFFModule[key];
    }
}

export default GeoTIFF;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/source/GeoTIFF.js';